module.exports = __webpack_public_path__ + "static/media/pro.8b1af151.png";